import { TOGGLE_FAVORITE_PLAN } from "./Actions";

export function favoritePlanIDs(state = [], action) {
  switch (action.type) {
    case TOGGLE_FAVORITE_PLAN:
      if (state.includes(action.planID)) {
        // Remove if already added
        return state.filter((id) => id !== action.planID);
      }
      // Otherwise add the plan to the list of favorite plans
      return state.concat(action.planID);

    default:
      return state;
  }
}
